export function handleLogout(removeCookie) {
  removeCookie("auth", {}, { path: "/" });
  removeCookie("user", {}, { path: "/" });
  localStorage.removeItem("accessToken");
}
